<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';

import { formatTodayLabel } from '../lib/userHealth';

const now = ref(new Date());
const label = computed(() => formatTodayLabel(now.value));

let clockTimer: ReturnType<typeof setInterval> | undefined;

onMounted(() => {
  clockTimer = setInterval(() => {
    now.value = new Date();
  }, 60_000);
});

onUnmounted(() => {
  if (clockTimer !== undefined) clearInterval(clockTimer);
});
</script>

<template>
  <time
    class="header__datetime"
    :datetime="now.toISOString()"
    aria-live="polite"
  >
    {{ label }}
  </time>
</template>
